import styles from './OurStory.module.css';

export default function OurStory() {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <span className={styles.label}>Our story</span>
        <div className={styles.body}>
          <p>
            B2B sales reps are trapped between speed and quality. They either dump accounts
            into stale databases and pitch people who quit six months ago, or they waste
            hours manually cross-referencing LinkedIn and data providers, or spend days
            wiring APIs together to build their own waterfall enrichment.
          </p>
          <p>
            RepBuddy was built out of pure personal frustration to fix this fragmentation.
            We don't just give you tools; we give you a team that actually talks to each
            other.
          </p>
        </div>
      </div>
    </section>
  );
}
